// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("D:\\repos\\com-brianastronaut\\src\\pages\\404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-etc-vr-setup-js": () => import("D:\\repos\\com-brianastronaut\\src\\pages\\etc-vr-setup.js" /* webpackChunkName: "component---src-pages-etc-vr-setup-js" */),
  "component---src-pages-index-js": () => import("D:\\repos\\com-brianastronaut\\src\\pages\\index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

